// extracted by mini-css-extract-plugin
export default {"captchaWrap":"Style_captchaWrap__XBIXA","loginAction":"Style_loginAction__cuB2q"};